import axios from 'axios'
import store from '@/store'
import { getToken, setToken, localRead } from '@/libs/util'
// import { Spin } from 'iview'
import { Modal } from 'view-ui-plus'
const addErrorLog = errorInfo => {
  const { statusText, status, request: { responseURL } } = errorInfo
  let info = {
    type: 'ajax',
    code: status,
    mes: statusText,
    url: responseURL
  }
  if (!responseURL.includes('save_error_logger')) store.dispatch('addErrorLog', info)
}

class HttpRequest {
  constructor (baseUrl = baseURL) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig () {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        //
      }
    }
    return config
  }
  destroy (url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors (instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      this.queue[url] = true
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      if (res.headers['Refreshed-Token']) {
        setToken(res.headers['Refreshed-Token'])
      }
      this.destroy(url)
      const { data, status } = res
      return { data, status }
    }, error => {
      this.destroy(url)
      addErrorLog(error.response)
      if (error.response && error.response.status==401 && error.response.data) {
          if (error.response.data.message === 'PASSWORD_INCORRECT') {
            return Promise.reject('密码错误，请重新登录！')
          } else {
            Modal.error({
              title: '您需要重新登录',
              content: `${error.response.data.message? ('理由：' + error.response.data.message) : ''}`,
              onOk: () => {
                setToken('')
                window.location.href= `${window.location.protocol}//${window.location.host}/#/login`
              },
            })
          }
      }
      return Promise.reject(error)
    })
  }
  request (options) {
    const instance = axios.create({
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'Authorization': `Bearer ${getToken()}`,
        'x-lang': localRead('local')
      }
    })
    // const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest
